import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {Link} from 'react-router-dom'

import style from './cards.sass'

@inject('store') @observer
class Cards extends Component {
  render() {
    return(
      <section styleName='wrapper'>
        <div className='landing-container' styleName='container'>
          <h2>Algoriz Pricing</h2>
          <p styleName='slogan'>Trade smarter with the most innovative Trading technology.</p>
          <div styleName='grid'>
            <div styleName='card'>
              <h3 styleName='lite'>Lite</h3>
              <span styleName='description'>Essentials for Beginners</span>
              <span styleName='price'>Free</span>
              <span styleName='period'>&nbsp;</span>
              <Link to='/signup/plan/1'>Sign up</Link>
            </div>
            <div styleName='card'>
              <h3 styleName='professional'>Professional</h3>
              <span styleName='description'>Advanced features for Professionals</span>
              <span styleName='price'>$29</span>
              <span styleName='period'>per month</span>
              <Link to='/signup/plan/2'>Try for free</Link>
            </div>
            <div styleName='card'>
              <h3 styleName='premium'>Premium</h3>
              <span styleName='description'>Complete Solution for your Trading needs</span>
              <span styleName='price'>$69</span>
              <span styleName='period'>per month</span>
              <Link to='/signup/plan/3'>Try for free</Link>
            </div>
            <div styleName='card'>
              <h3 styleName='enterprise'>Enterprise</h3>
              <span styleName='description'>Customized Solution for your trading house</span>
              <span styleName='price'>Custom</span>
              <span styleName='period'>Custom</span>
              <Link to='/free-trial'>Contact us</Link>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default Cards
